import React from "react";
import { Spinner } from "reactstrap";

const SpinnerComponent = ({ styles, spinnerStyles }) => {
  return (
    <>
      <div style={spinnerStyles ? spinnerStyles : {}}>
        <Spinner style={{ color: "#3a5deb" }}></Spinner>
      </div>
      <span style={styles ? styles : { marginTop: 5, marginLeft: 5, textAlign: "center" }}>
        Loading
      </span>
    </>
  );
};

export default SpinnerComponent;
